import { Line } from "./line.model";

export class InsertionCycle {
    public id: number;
    public name: string;
    public assignedLines: Line[];
    public assignedLinesString: string;
    public inUse: boolean;

    constructor(insertionCycle: any = {}) {
        this.id = insertionCycle.id || 0;
        this.name = insertionCycle.name || '';
        this.assignedLines = this.mapLines(insertionCycle.assignedLines || []);
        this.assignedLinesString = insertionCycle.assignedLinesString || '';
        this.inUse = insertionCycle.inUser || false;
    }

    mapLines(lines = []): Line[] {
        return lines.map(line => new Line(line));
    }
}
